import { Link } from "react-router-dom";
import { Box, PlayCircle, Sun, Boxes, Truck, ShieldCheck, ArrowUpRight, HelpCircle, RotateCcw, CreditCard } from "lucide-react";
import { img } from "../lib/api";
import { useApp } from "../context/AppContext";

import { tx, useLang } from "../lib/i18n";
const FEATURES = [
  ["orbit", Box, "/experience/orbit"], ["moments", PlayCircle, "/experience/moments"], ["mood", Sun, "/experience/mood"],
  ["space", Boxes, "/experience/space"], ["parcel", Truck, "/track-order"], ["secure", ShieldCheck, "/experience/secure"],
];

export const FeatureRail = () => { useLang();
  const { t } = useApp();
  return (
    <div className="mv-glass rounded-2xl px-4 py-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="feature-rail">
      {FEATURES.map(([k, Icon, to]) => (
        <Link key={k} to={to} data-testid={`feature-rail-${k}`} className="group flex items-center gap-3 rounded-xl px-2 py-2 hover:bg-white/[0.03] transition-colors">
          <Icon className={`h-6 w-6 shrink-0 ${k === "mood" ? "text-amber-300" : "text-[var(--mv-teal)]"}`} strokeWidth={1.5} />
          <span className="min-w-0">
            <span className="block text-[13px] font-semibold text-[var(--mv-text)] group-hover:text-[var(--mv-teal)] transition-colors">{t(`feat.${k}`)}</span>
            <span className="block truncate text-[11px] text-[var(--mv-dim)]">{t(`feat.${k}.sub`)}</span>
          </span>
        </Link>
      ))}
    </div>
  );
};

export const CollectionCard = ({ c, idx = 0 }) => { useLang();
  const { t } = useApp();
  return (
    <Link to={`/collections/${c.slug}`} data-testid={`collection-card-${c.slug}`} style={{ animationDelay: `${idx * 90}ms` }}
      className="mv-reveal group relative block h-[200px] lg:h-[210px] overflow-hidden rounded-2xl border border-[var(--mv-border)]">
      <img src={img(c.image)} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-right transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/35 to-transparent" />
      <div className="relative flex h-full flex-col justify-between p-6">
        <div>
          <p className="text-[11px] font-semibold tracking-[0.18em] text-[var(--mv-muted)]">{tx(c.eyebrow)}</p>
          <h3 className="mt-3 max-w-[60%] text-xl lg:text-[22px] font-medium leading-tight text-[var(--mv-text)]">{tx(c.headline)}</h3>
        </div>
        <span className="flex items-center gap-2 text-xs font-medium text-[var(--mv-text)]">{t("common.shopNow")} <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
      </div>
    </Link>
  );
};

const TRUST_ICONS = { help: HelpCircle, truck: Truck, rotate: RotateCcw, card: CreditCard, shield: ShieldCheck };

export const TrustRail = ({ items = [] }) => { useLang(); return (
  <div className="mx-auto flex w-fit max-w-full flex-wrap justify-center gap-x-8 gap-y-3 rounded-2xl mv-glass px-6 py-3" data-testid="trust-rail">
    {items.filter((i) => i.enabled).map((i) => {
      const Icon = TRUST_ICONS[i.icon] || HelpCircle;
      return (
        <Link to="/about" key={i.title} className="flex items-center gap-2.5 hover:opacity-80" data-testid={`trust-item-${i.icon}`}>
          <Icon className="h-4 w-4 text-[var(--mv-muted)]" />
          <span><span className="block text-xs font-semibold">{tx(i.title)}</span><span className="block text-[10px] text-[var(--mv-dim)]">{tx(i.subtitle)}</span></span>
        </Link>
      );
    })}
  </div>
); };
